import { ErrorType } from '../domains/common.domain';

export abstract class TaxIdBase {
  public getFormattedTaxId(value: string, isOnlyCPF: boolean = false): string {
    return value;
  }

  public getFormattedStateTaxId(value: string): string {
    return value;
  }

  public getFormattedNationalId(value: string): string {
    return value;
  }

  public isTaxIdValid(taxId: string, isOnlyCPF: boolean = false): boolean {
    return true;
  }

  public isNationalIdValid(nationalId: string): boolean {
    return true;
  }

  public validateStateTaxId(taxId: string): ErrorType | undefined {
    return undefined;
  }
}
